import React from "react";

const StarRating = ({ rating, size = "fs-5" }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <div className="d-inline-flex">
      {[...Array(fullStars)].map((_, i) => (
        <span key={i} className={`text-warning ${size}`}>
          ★
        </span>
      ))}
      {halfStar && <span className={`text-warning ${size}`}>⯨</span>}

      {[...Array(emptyStars)].map((_, i) => (
        <span key={i} className={`text-secondary ${size}`}>
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
